import React from 'react';
import { theme } from '../../config/theme';

const LoadingSpinner = ({ size = 'md', color = theme.colors.primary.main, fullScreen = false }) => {
  const sizes = {
    sm: '20px',
    md: '40px',
    lg: '60px',
  };

  const containerStyles = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: theme.zIndex.modal,
  } : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const spinnerSize = sizes[size] || sizes.md;

  return (
    <div style={containerStyles}>
      <svg
        width={spinnerSize}
        height={spinnerSize}
        viewBox="0 0 24 24"
        fill="none"
        style={{ animation: 'spin 1s linear infinite' }}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke={color}
          strokeWidth="4"
          strokeOpacity="0.3"
        />
        <path
          d="M12 2a10 10 0 0 1 10 10"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;